import { cloneDeep } from 'lodash'

import { generateId } from '@/entities/utils/helpers'

type CloneableWidget = {
  id: string
}

export const cloneDashboardWidgets = <T extends CloneableWidget>(
  widgets: T[] | undefined,
) => {
  if (!widgets?.length) return widgets
  return cloneDeep(widgets).map(widget => ({
    ...widget,
    id: generateId(),
  }))
}
